function resetForm(arr) {
  arr.forEach((setValue) => {
    setValue("");
  });
}

export default resetForm;
